import { PrintLabelContentViewModel } from '../../print-label-content-view-model';
import { Injectable } from '@angular/core';

@Injectable()
export class BaseInventoryLabelStackContentViewModel extends PrintLabelContentViewModel {}
